module.exports = __webpack_public_path__ + "static/media/Freddy.b24921e2.webp";